import Babylon from "../../components/WebGL";

const Home = () => {
  return (
    <div>
      <Babylon />
    </div>
  );
};

export default Home;
